// These scene types are "rooms" where players exist and can see each other:
export const ALL_ROOM_SCENE_TYPES = ['lobby', 'poker', 'mttStaging'];
